import React from 'react';
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import StaffForm from "./StaffForm";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 'xl',
    maxHeight: "90%",
    overflow: "auto",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const StaffModalForm = ({open, handleClose}) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <StaffForm/>
            </Box>

        </Modal>
    );
};

export default StaffModalForm;